import { computed } from '@angular/core';
import { InternalAuthService } from '@eforall/common';
import { DashboardFrameConfig, DashboardMenuItem } from '@eforall/dashboard';
import { environment } from '../../environments';


export function getDashboardFrameConfig(auth: InternalAuthService) {
	return computed(() => {


		const menuItems: DashboardMenuItem[] = [
			{
				label: 'Home',
				routerLink: '/',
				icon: 'fa-light fa-earth-americas',
				separator: false,
			},
			{
				label: 'Devo',
				icon: 'fa-light fa-folder-gear',
				routerLink: '/devo',
				subMenu: [{
					label: 'Pipeline',
					routerLink: '/devo/pipeline',
					icon: 'fa-light fa-ballot-check',
				},
				{
					label: 'Donors',
					routerLink: '/devo/donors',
					icon: 'fa-light fa-gauge-high',
				},
				{
					label: 'Commitments',
					routerLink: '/devo/commitments',
					icon: 'fa-light fa-sliders',
				},
				],
				separator: true,
			},
			{
				label: 'Finance',
				icon: 'fa-light fa-user-tie',
				routerLink: '/finance',
				subMenu: [
					{
						label: 'Awards',
						routerLink: '/finance/awards',
						icon: 'fa-light fa-grid',
					},
					{
						label: 'Cost',
						routerLink: '/finance/cost',
						icon: 'fa-light fa-message-arrow-up-right',
					},
				],
				separator: false,
			},
		];


		const items: DashboardFrameConfig = {
			appName: 'Devo',
			environmentName: environment.name,
			menu: menuItems,
			signOut: auth.signOut,
		}
		return items;
	});
}